
<template>

</template>

<script>
import { Options, Vue } from 'vue-class-component';
// import HelloWorld from '@/components/HelloWorld.vue';

@Options({
 
})

export default class HomeView extends Vue {
  // data() {
  //   return {
  //     deviceCB: null,
  //     currentDevice: null,
  //   };
  // }  
  mounted() {
    // console.log("hello")
    parent.postMessage(location.href, location.origin);
  }

}
 
</script>